import { render } from "./StudentResult.vue?vue&type=template&id=4df8843d&scoped=true"
import script from "./StudentResult.vue?vue&type=script&lang=js"
export * from "./StudentResult.vue?vue&type=script&lang=js"

import "./StudentResult.vue?vue&type=style&index=0&id=4df8843d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df8843d"]])

export default __exports__